import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  CurrencyService,
} from '@spartacus/core'
import { switchMap, debounceTime, take, filter } from 'rxjs/operators'
import { of } from 'rxjs'
import { PlpService } from '../plp.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { Router } from '@angular/router'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { Product } from '../../../models/product.model'
import { userRoles } from '../../../models/user.model'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,

  selector: 'vs-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemComponent implements OnInit {
  @Input() product: Product | any
  public userRoles = userRoles
  public view = 'list'
  totalQuantity = 1
  totalPrice: any
  loggedIn = false
  currentUser: any
  favStatus: boolean
  checkPriceProduct = {}
  currency: string
  hideProductPrice = false
  showError: boolean = false

  constructor(
    public auth: AuthService,
    public plpService: PlpService,
    public commonService: CommonService,
    private globalMessageService: GlobalMessageService,
    private cd: ChangeDetectorRef,
    private currencyService: CurrencyService,
    private userAccountFacade: UserAccountFacade,
    public router: Router,
    private launchDialogService: LaunchDialogService
  ) {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  user$ = this.auth.isUserLoggedIn().pipe(
    switchMap((isUserLoggedIn) => {
      if (isUserLoggedIn) {
        return this.userAccountFacade.get()
      } else {
        return of(undefined)
      }
    })
  )

  ngOnInit() {
    this.currencyService.getActive().subscribe(
      (currency) => {
        this.currency = currency
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.fetchCurrentUser()
    this.favStatus = this.product['favouritesFlag']
    this.hideProductPrice = this.product?.hidePrice
  }
  increaseQuantity(product) {
    if (this.totalQuantity > 5) {
    } else {
      // product.quantity = product.quantity + 1;
      this.totalQuantity = this.totalQuantity + 1

      // this.totalPrice = this.totalPrice + product.unitPrice;
    }
  }
  decreaseQuantity(product) {
    if (this.totalQuantity < 0) {
    } else {
      // product.quantity = product.quantity - 1;
      this.totalQuantity = this.totalQuantity - 1

      //  this.totalPrice = this.totalPrice - product.unitPrice;
    }
  }

  fetchCurrentUser() {
    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
      },
      (err) => {
        this.globalMessageService.add(
          err,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  updateFavioriteProduct(product, value?) {
    // make a call - POST/PUT API - to update the favorite status of the product
    this.plpService
      .updateProductFavouriteStatus(product, value)
      .pipe(debounceTime(500))
      .subscribe(
        (response) => {
          if (response !== undefined) {
            switch (response.toString()) {
              case 'true':
                this.favStatus = true
                this.cd.markForCheck()
                break
              case 'false':
                this.favStatus = false
                this.cd.markForCheck()
                break
              case 'maxlimitreached':
                this.favStatus = false
                this.cd.markForCheck()
                this.displayMaxFavAttainedMsg()
                break
            }
          }
        },
        (error) => {
          this.favStatus = !this.favStatus // revert the status which you had updated before the API call.
          this.cd.markForCheck()
          this.globalMessageService.add(
            { key: 'plp.issueWhileUpdate' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  onFavoriteClick(product) {
    // My favourites dialog box
    if (!this.favStatus) {
      const componentdata = {}

      const favouritePdpDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.MY_FAVOURITES_PDP,
        undefined,
        undefined,
        componentdata
      )
      if (favouritePdpDialog) {
        favouritePdpDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose
          .pipe(
            filter(
              (dialogResponse: DialogResponse) =>
                dialogResponse?.type == VS_LAUNCH_CALLER.MY_FAVOURITES_PDP
            ),
            take(1)
          )
          .subscribe((value) => {
            if (value?.data?.myfavdescription) {
              this.favStatus = !this.favStatus //display to end user - that the product has changed his fav status
              this.updateFavioriteProduct(
                product,
                value?.data?.myfavdescription
              )
            }
          })
      }
    } else {
      this.favStatus = !this.favStatus
      this.updateFavioriteProduct(product)
    }
  }

  displayMaxFavAttainedMsg() {
    this.globalMessageService.add(
      { key: 'plp.maximumItemsAdded' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  // CHECK PRICE CUSTOMIZATION ------------ START
  fetchCheckPriceProductObj(event) {
    this.checkPriceProduct = event
    this.hideProductPrice = false
    this.cd.detectChanges()
  }
  // CHECK PRICE CUSTOMIZATION ------------ END
  priceNotFound(event) {
    this.showError = event
  }
}
